// Static widget metadata per role. Renderers live in the dashboard pages
// (they close over page state); ids here are the stable keys stored in
// each user's saved layout — never rename an id casually.
//
// Sizing: `size: 'half'` widgets share one uniform height; `size: 'full'`
// widgets with `tall: true` share a second uniform height (content scrolls
// inside); full widgets without `tall` (e.g. Quick Actions) stay auto-height
// bars. Heights live in WidgetShell.
//
// `locked: true` pins a widget to the front of the grid: no drag handle, no
// hide button, and saved layouts that moved or hid it are overridden.
export const THERAPIST_WIDGETS = [
  { id: 'profile', title: 'My Profile', size: 'half', locked: true },
  { id: 'stats', title: 'My Stats', size: 'half' },
  { id: 'team', title: 'Team', size: 'half' },
  { id: 'quickActions', title: 'Quick Actions', size: 'full' },
  { id: 'schedule', title: 'My Schedule', size: 'full', tall: true },
  { id: 'canvas', title: 'Community Canvas', size: 'full', tall: true },
];

export const ADMIN_WIDGETS = [
  { id: 'quickActions', title: 'Quick Actions', size: 'full' },
  { id: 'team', title: 'Team', size: 'half' },
  { id: 'myProfile', title: 'My Profile', size: 'half' },
  { id: 'newClientRequests', title: 'New Client Requests', size: 'half' },
  { id: 'calendarManager', title: 'Calendar Manager', size: 'full', tall: true },
  { id: 'practiceOverview', title: 'Practice Overview', size: 'full', tall: true },
  { id: 'trends', title: 'Therapists Stats & Trends', size: 'full', tall: true, visibleWhen: (ctx) => ctx.has ? ctx.has('revenue') : !ctx.limited },
  { id: 'exports', title: 'Exports', size: 'full', tall: true, visibleWhen: (ctx) => ctx.has ? (ctx.has('qb_export') || ctx.has('payroll')) : !ctx.limited },
  { id: 'canvas', title: 'Community Canvas', size: 'full', tall: true },
];
